<template>
    <div class="box">
        <div class="hello-ezuikit-js"  v-if="videoType=='1'">
            <div id="video-container" style="width:100%;height:100%">
                <div style="position:absolute;right:5px;bottom:5px" v-show="player">
                    <img src="../../assets/images/fullScreen.png" @click="fullScreen" alt="">
                </div>
            </div>
            <div class="mubiao_close" @click="hideClose" v-if="showClose">
                <Icon type="md-close" />
            </div>
        </div>
        <div v-else-if="videoType=='2'">
            <hk-video v-if="videoType=='2' && hkUrl" :previewUrl="hkUrl" :VWidth="width+''" :VHeight="height+''" :videoId="videoId" :channelNum="channelNum" :sid="videoSid"></hk-video>
        </div>
        <div v-else-if="videoType=='4'">
            <h5-video v-if="videoType=='4' && hkUrl" :previewUrl="hkUrl" :VWidth="width+''" :VHeight="height+''" :videoId="videoId" :channelNum="channelNum" :sid="videoSid"></h5-video>
        </div>
        <div v-else-if="videoType=='5'">
            <iframe allowtransparency="yes" allowfullscreen="yes" width="100%" :height="height" v-if="hkUrl" :src="hkUrl" frameborder="0"></iframe>
        </div>
        <div v-else :style="'width:'+width+'px;height:'+height+'px;'">
           <video id="ico_video" class="video-js vjs-default-skin" controls preload="auto">
                <source :src="previewUrl" type="application/x-mpegURL">
            </video>
            <div class="mubiao_close" @click="hideClose" v-if="showClose">
                <Icon type="md-close" />
            </div>
        </div>
    </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
//引入video.js
import videojs from 'video.js'
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
import getRandVal from '@/assets/js/index';
import 'videojs-contrib-hls'
import hkVideo from "./hkVideo/hkVideo";
import h5Video from "./h5Video/h5Video";
export default {
  name: "playVideo",
  props: {
    previewUrl: String,
    width:{
        default:700
    },
    height:{
        default:350
    },
    showClose:{
        default:true
    },
    channelNum: {
      default: "",
    },
    videoSid: {
      default: "",
    },
    videoId: {
        default:"001"
    },
    videoDeviceId: {
        default:""
    }
  },
  data(){
      return{
            player:null,
            videoType: "1", // 1萤石 2海康 3普通
            video_player: null,
            accessToken:'',
            hkUrl:"",
      } 
      
  },
  components: {
    hkVideo,
    h5Video
  },
  methods:{
    hideClose(){
        this.$emit('hideClose')
    },
    videoInit(str){
        if(this.video_player){
            this.video_player.src(this.previewUrl);
            this.video_player.play();
            return;
        }
        this.video_player = videojs(str, {
            src: this.previewUrl,
            autoplay: true,
        },function(){
            this.play();
        });
    },
     //获取数据开始
    getPwdHash(pwd, data) {
        var sha = md5(pwd + data);
        var base = new Base64();
        var pwdHashStr = base.encode(sha);
        return pwdHashStr;
    },
    //获取mp4视频地址
    getQlyVideoUrl() {
      return new Promise((resolve, reject) => {
          let dataObj = {
              type: "get",
              url: `/mcbw/cameras/qly/${this.videoDeviceId}`,
              obj: {
              
              },
          };
          this.$Axios(dataObj).then((res) => {
              if (res.data.success) {
                  resolve(res.data);
              }
          });
      });
    },
    getToken(){
        console.log(this.previewUrl)
         let _that = this;
        if(this.previewUrl == "mp4") {
            this.getQlyVideoUrl().then((res) => {
                if (res.success && res.data.includes("mp4")) {
                setTimeout(() => { 
                    _that.hkUrl = res.data;
                    _that.videoType = "5";
                }, 3000);
                }
            });
        } else if(this.previewUrl.includes('http')){
            this.videoType = "3";
            this.$nextTick(()=>{
                this.videoInit('ico_video');
            });
        } else  if(this.previewUrl.includes('rtsp://')){
            this.videoType = "2";
        } else  if(this.previewUrl.includes('ws://') || this.previewUrl.includes('wss://')){
            this.videoType = "4";
        } else{
            var data = {
                type: 'get',
                url: `/mcbw/cameras/token`,
                obj: {}
            };
            this.$Axios(data).then((res) => {
                console.log(res)
                if (res.data.success) {
                    this.accessToken = res.data.data
                    console.log(this.accessToken)
                    this.videoType = "1";
                    this.player =  new EZUIKit.EZUIKitPlayer({
                    autoplay: true,
                    id: "video-container",
                    accessToken:this.accessToken,
                    url: this.previewUrl,
                    template: "simple", // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
                    // 视频上方头部控件
                    //header: ["capturePicture", "save", "zoom"], // 如果templete参数不为simple,该字段将被覆盖
                    //plugin: ['talk'],                       // 加载插件，talk-对讲
                    // 视频下方底部控件
                    // footer: ["talk", "broadcast", "hd", "fullScreen"], // 如果template参数不为simple,该字段将被覆盖
                    // audio: 1, // 是否默认开启声音 0 - 关闭 1 - 开启
                    // openSoundCallBack: data => console.log("开启声音回调", data),
                    // closeSoundCallBack: data => console.log("关闭声音回调", data),
                    // startSaveCallBack: data => console.log("开始录像回调", data),
                    // stopSaveCallBack: data => console.log("录像回调", data),
                    // capturePictureCallBack: data => console.log("截图成功回调", data),
                    // fullScreenCallBack: data => console.log("全屏回调", data),
                    // getOSDTimeCallBack: data => console.log("获取OSDTime回调", data),
                        width: this.width,
                        height: this.height
                    });
                    this.$nextTick(()=>{
                        console.log(document.getElementsByClassName('contros'))
                    })
                }
            })
        }
    },
    fullScreen(){
        this.player ? this.player.opt.fullScreenStatus = 0 : ''
        this.player.fullScreen()
    }
  },
  mounted(){
    this.hkUrl = this.previewUrl;
    this.getToken()
  },
  destroyed(){
    if (this.previewUrl.includes("ezopen")) {
      this.player = null;
    } else if (this.previewUrl.includes("rtsp://")) {
      this.hkUrl = "";
    } else if (this.previewUrl.includes('ws://') || this.previewUrl.includes('wss://')) {
      this.hkUrl = "";
    } else {
      this.hkUrl = "";
      this.video_player.dispose();
    }
  }
};
</script>
<style>

</style>
<style scoped lang="scss">
    .box,.box>div,.hello-ezuikit-js {
        width: 100%;
        height: 100%;
    }
    .video-js, video{
        width: 100%;
        height: 100%;
        min-height: 350px;
    }
    .video-js, .vjs-fullscreen-control{
        outline: none;
    }
    .mubiao_close{
        position: absolute;
        right: 0;
        top: 0;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        overflow: hidden;
        background: none;
        cursor: pointer;
        z-index: 1;
        i{
            font-size: 20px;
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/videoPlay/videoPlay.vue